import MaterialFormGroup, { FormGroupProps } from "@mui/material/FormGroup";
import React, { FC } from "react";

export const FormGroup: FC<FormGroupProps> = (props) => <MaterialFormGroup {...(props as any)} />;
